import * as React from 'react';
import { Col, Container, Nav, Row } from 'react-bootstrap';
import {
  Navigate,
  Route,
  Routes,
  useLocation,
  useNavigate,
} from 'react-router-dom';
import Content from '../../Abstracts/Content/Content';
// @ts-ignore
import style from './Information.module.scss?module';
import Legal from './Legal/Legal';
import Faq from './Faq/Faq';
import Messages from './Messages/Messages';
import { useUser } from '../../../../Context/UserContext';

const BASE_PATH = '/virtual-trade-show/help-center';
const FAQ_PATH = `${BASE_PATH}/faq`;
const MESSAGES_PATH = `${BASE_PATH}/messages`;

function FaqTab() {
  return (
    <>
      <Faq />
      <Legal />
    </>
  );
}

function MessagesTab() {
  return <Messages isActive />;
}

export default function Information() {
  const { user } = useUser();
  const location = useLocation();
  const navigate = useNavigate();

  const activeKey = location.pathname.endsWith('/messages') ? 'messages' : 'faq';

  const handleTabSelect = (key: string | null) => {
    if (!key) return;
    if (key === 'messages') navigate(MESSAGES_PATH);
    else navigate(FAQ_PATH);
  };

  return (
    <Content>
      <Container className={style.Information}>
        <Row>
          <Col>
            <h1>Help Center</h1>
            <p className={style.Subtitle}>
              Find quick answers or contact our team if you need help.
            </p>
          </Col>
        </Row>
        {user ? (
          <>
            <Row>
              <Col>
                <Nav
                  variant="tabs"
                  className={style.Tabs}
                  activeKey={activeKey}
                  onSelect={handleTabSelect}
                >
                  <Nav.Item>
                    <Nav.Link eventKey="faq">FAQ</Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link eventKey="messages">Messages</Nav.Link>
                  </Nav.Item>
                </Nav>
              </Col>
            </Row>
            <Row>
              <Col>
                <div className={style.TabContent}>
                  <Routes>
                    <Route index element={<Navigate replace to="faq" />} />
                    <Route path="faq" element={<FaqTab />} />
                    <Route path="messages" element={<MessagesTab />} />
                    <Route path="*" element={<Navigate replace to="faq" />} />
                  </Routes>
                </div>
              </Col>
            </Row>
          </>
        ) : (
          <>
            <Faq />
            <Legal />
          </>
        )}
      </Container>
    </Content>
  );
}
